import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

function LinkedInLink({ children }: { children: React.ReactNode }) {
  return (
    <a
      href="https://www.linkedin.com/in/gautier-labarre-6b1530146/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon icon={faLinkedinIn} data-testid="icon" />
      {children}
    </a>
  );
}

export default LinkedInLink;
